import React from "react";
import { Icon, Reveal, Overline } from "./primitives";
import { WHY_AJMUS } from "../../data/content";

export default function WhyAjmus() {
  return (
    <section id="why" className="relative bg-white py-20 sm:py-28" data-testid="section-why">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <Reveal>
          <div className="max-w-2xl">
            <Overline>Why AJMUS</Overline>
            <h2 className="mt-4 font-heading text-4xl font-extrabold tracking-tight text-ajmus-ink sm:text-5xl">
              Why Organisations Choose AJMUS
            </h2>
          </div>
        </Reveal>

        <div className="mt-14 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {WHY_AJMUS.map((item, i) => (
            <Reveal key={item.title} delay={(i % 3) * 0.08}>
              <div className="group h-full rounded-3xl border border-black/5 bg-[#FAFAFA] p-7 transition-transform transition-shadow duration-300 ease-out hover:-translate-y-1 hover:bg-white hover:shadow-[0_20px_50px_rgb(11,19,43,0.07)]">
                <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-ajmus-navy text-white transition-colors duration-300 group-hover:bg-ajmus-royal">
                  <Icon name={item.icon} size={22} />
                </span>
                <h3 className="mt-5 font-heading text-lg font-bold tracking-tight text-ajmus-ink">
                  {item.title}
                </h3>
                <p className="mt-2.5 text-sm leading-relaxed text-ajmus-steel">{item.body}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
